import { FC, useState, useEffect } from "react";
import "./Home.css";
import { quotesRequest } from "../../requests/quotes";
import { Quotes } from "../../types/types";

const Home: FC = () => {
  const [quotes, setQuotes] = useState<Quotes.Quote[]>([]);
  const [randomQuote, setRandomQuote] = useState<string>("Публичная версия");
  useEffect(() => {
    quotesRequest().then(({ payload }) => setQuotes(payload));
  }, []);

  const handleClick = () => {
    setRandomQuote(quotes[Math.floor(Math.random() * quotes.length)].quote);
  };

  return (
    <section className="section-home">
      <div className="img-box">
        <img
          src={require("../../assets/images/hero-pic2.png")}
          alt="Sad face Emoji"
        />
      </div>
      <div className="text-box">
        <div className="text-box-inner">
          <h1 className="heading">РявХаб</h1>
          <p className="info-text">{randomQuote}</p>
          <button className="hero-btn" onClick={handleClick}>
            Сгенерировать цитату
          </button>
        </div>
      </div>
    </section>
  );
};
export default Home;
